<template>
    <div id="action-edit">
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         src="@/assets/theme/light/status/01dailyActive/01back.svg">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title" v-if="$i18n.locale == 'en'">{{ actionDesc.actionNameEn }}</div>
                        <div class="banner-title" v-else-if="$i18n.locale == 'ja'">{{ actionDesc.actionNameJa }}</div>
                        <div class="banner-title" v-else>{{ actionDesc.actionName }}</div>
                    </van-col>
                    <van-col span="6">
                        <div class="save" v-if="actionDesc.customize" @click="toActionEdit">{{
                                $t('actionDesc.delete')
                            }}
                        </div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content">
            <video class="video-box" v-if="actionDesc.customize === 0" :src="actionDesc.videoUrl" autoplay loop muted @contextmenu.prevent width="345"
                   height="194" :key="videoKey"></video>
            <div class="item-title">{{ $t('actionDesc.part') }}</div>
            <div class="muscles-box">
                <div class="muscles-item" :class="{'active' : muscles[index] == 1 }"
                     v-for="(muscles, index) in muscles">{{ muscles }}
                </div>
            </div>
            <div class="item-title">{{ $t('actionDesc.point') }}</div>
            <div class="point-box" v-html="dealIntroduce"></div>
            <div class="part-img-box">
                <div class="part-item-title">{{ $t('actionDesc.part') }}</div>
                <div class="part-icon-box">
                    <img class="part-icon" src="@/assets/theme/light/trainPlan/10sportDesc/16.svg">
                    <img class="part-icon" v-for="item in musclesIcon" :src="item">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {Dialog} from "vant";
import {WebJSBridge} from "../../utils/JSBridge1";

export default {
    name: 'actionDesc',
    data() {
        return {
            actionId: '',
            actionDesc: {},
            muscles: [],
            videoKey: 0,
            musclesIcon: []
        }
    },
    mounted() {
        if (this.$route.query.actionId) {
            this.actionId = this.$route.query.actionId;
        }
        this.getActionById();
    },
    watch: {
        $route(to, from) {
            // 在路由改变时重新加载数据
            if (this.$route.query.actionId) {
                this.actionId = this.$route.query.actionId;
            }
            this.getActionById();
            this.videoKey++;
        }
    },
    methods: {
        back() {
            this.$router.back();
        },
        getActionById() {
            this.$api.trainPlan.getActionById({
                actionId: this.actionId
            }).then(res => {
                this.actionDesc = res.info;
                let muscles = this.actionDesc.trainMuscles.split(',');
                this.muscles = [];
                this.musclesIcon = [];
                for (let i = 0; i < muscles.length; i++) {
                    this.muscles.push(this.$t('actionLibrary.muscles' + muscles[i]));
                    this.musclesIcon.push(require('@/assets/theme/light/trainPlan/10sportDesc/'+muscles[i]+'.svg'));
                }
            })
        },
        toActionEdit() {
            Dialog.confirm({
                title: this.$t('actionEdit.deleteTitle'),
                message: this.$t('actionEdit.deleteDesc'),
                getContainer: "#action-edit",
                confirmButtonColor: 'var(--chart-color-1)',
                confirmButtonText: this.$t('actionEdit.confirm'),
                cancelButtonText: this.$t('actionEdit.cancel'),
                cancelButtonColor: 'rgb(133 130 130)',
            }).then(() => {
                this.$api.trainPlan.deleteAction({
                    actionId: this.actionDesc.actionId
                }).then(res => {
                    WebJSBridge.call("actionEditSuccess", {
                        updateTime: res.info
                    }, function (res) {
                    });
                    this.$router.back();
                })
            }).catch(() => {
            });
        },
    },
    computed: {
        dealIntroduce() {
            if (!this.actionDesc.actionIntroduce) return
            if (this.$i18n.locale == 'en') {
                return this.actionDesc.actionIntroduceEn.replace(/\./g, '.<br>');
            } else if (this.$i18n.locale == 'ja') {
                return this.actionDesc.actionIntroduceJa.replace(/\。/g, '。<br>');
            } else {
                return this.actionDesc.actionIntroduce.replace(/\。/g, '。<br>');
            }
        }
    }
}
</script>

<style scoped>
.content {
    width: 100%;
    margin-top: 98px;
}

.video-box {
    width: 345px;
    height: 194px;
    background: var(--bg-color-2);
    margin: 0 15px 20px 15px;
}

.item-title {
    font-size: 17px;
    color: var(--text-color-1);
    margin-left: 16px;
    margin-bottom: 10px;
}

.part-box {
    margin-left: 16px;
    margin-bottom: 20px;
}

.part-item {
    font-size: 15px;
    color: var(--text-color-1);
    background: var(--bg-color-2);
    border-radius: 15px 15px 15px 15px;
    padding: 4px 11px;
}

.point-box {
    width: 317px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin: 0 auto;
    font-size: 15px;
    line-height: 23px;
    color: var(--text-color-1);
    padding: 12px 14px;
}

.part-img-box {
    width: 345px;
    height: 274px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin: 10px auto;
}

.part-item-title {
    font-size: 15px;
    color: var(--text-color-1);
    margin-left: 15px;
    padding-top: 16px;
}

.save {
    font-size: 15px;
    color: #FF0101;
    text-align: right;
    margin: 13px 19px;
    line-height: 19px;
}

.muscles-box {
    width: 345px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
}

.muscles-item {
    background-color: var(--bg-color-2);
    color: var(--text-color-2);
    border-radius: 15px 15px 15px 15px;
    padding: 8px 14px;
    font-size: 12px;
    margin-right: 4px;
    margin-bottom: 8px;
    width: 48px;
    text-align: center;
    display: flex; /* 使用 Flexbox */
    align-items: center; /* 垂直居中 */
    justify-content: center; /* 水平居中 */
}

/deep/ .van-dialog__header {
    font-size: 19px;
    color: var(--text-color-1);
}

/deep/ .van-dialog__message {
    text-align: center;
}

.part-icon-box {
    width: 245px;
    margin: 15px 50px 0 50px;
    position: relative;
}

.part-icon {
    width: 245px;
    position: absolute;
}
</style>


// WEBPACK FOOTER //
// src/views/trainPlan/03actionDesc.vue